<template><div><h1 id="eb-mehrwertsteuer-journal" tabindex="-1"><a class="header-anchor" href="#eb-mehrwertsteuer-journal"><span>EB-Mehrwertsteuer-Journal</span></a></h1>
<p>EB-Mehrwertsteuer-Journal — Lister Einzelbuchungen aus dem Warenverkauf mit detaillierten MWST-Informationen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste der Einzelbuchungen aus dem Warenverkauf, die den eingegebenen Parametern entsprechen, mit detaillierten MWST-Informationen. Die auszuwertende Journalnummer muss eingegeben werden. Zusätzlich kann nach Personen-ID, Personenmerkmal und Belegdatum weiter eingegrenzt werden. Die Anzeige resp. die Ausgabe kann so bestimmt werden, dass nur Buchungen ohne MWST-Informationen oder nur Buchungen mit Differenzen oder alle Buchungen angezeigt werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → EB-Kontoauszüge → EB-Mehrwertsteuer-Journal</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von Personen-ID</dt>
<dd>Personen-ID, ? = unbegrenzt</dd>
<dt>bis Personen-ID</dt>
<dd>Personen-ID, ? = unbegrenzt</dd>
<dt>von Journalnummer</dt>
<dd>Journalnummer, Muss-Eingabe</dd>
<dt>bis Journalnummer</dt>
<dd>Journalnummer, Muss-Eingabe</dd>
<dt>von Datum</dt>
<dd>von Belegdatum, ? = unbegrenzt</dd>
<dt>bis Datum</dt>
<dd>bis Belegdatum, ? = unbegrenzt</dd>
<dt>Ausgabe von</dt>
<dd>Ausgabe, Auswahl von:<br>allen Buchungen = es werden alle Buchungen die den Parameterkriterien entsprechen aufgelistet<br>nur Buchungen ohne MWSt = es werden nur Buchungen ohne MWSt aufgelistet<br>nur Buchungen mit Differenzen = es werden nur Buchungen mit Differenzen aufgelistet (Differenz zwischen gebucht und errechnetem Betrag)</dd>
<dt>Mandanten</dt>
<dd>Mandanten, mit Kommas trennen, mit ! ausschliessen, * = alle</dd>
<dt>nur mit Merkmal</dt>
<dd>nur Einzelbuchungen für Adressen mit aufgeführten Merkmalen werden verarbeitet</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
<dt>Bildschirm:</dt>
<dd>ja</dd>
<dt>Drucker/Format:</dt>
<dd>A4 quer</dd>
<dt>Hintergrundverarb.:</dt>
<dd>ja</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>FaktNr</td>
<td>Fakturanummer</td>
</tr>
<tr>
<td>Adresse</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Name</td>
<td>Adressname</td>
</tr>
<tr>
<td>Datum</td>
<td>Einzelbuchung Belegdatum</td>
</tr>
<tr>
<td>S</td>
<td>Einzelbuchung MWST-Code</td>
</tr>
<tr>
<td>Entgelt</td>
<td>Total Warenbetrag pro Fakturanummer/Personen-ID/MWST-Code/Soll- und Habenkonto</td>
</tr>
<tr>
<td>MWSt gebucht</td>
<td>Total gebuchter MWST-Betrag pro Fakturanummer/Personen-ID /MWST-Code/Soll- und Habenkonto</td>
</tr>
<tr>
<td>MWSt errechnet</td>
<td>Total errechnet MWST-Betrag pro Fakturanummer/Personen-ID /MWST-Code/Soll- Haben Konto</td>
</tr>
<tr>
<td>Differenz</td>
<td>MWST errechnet - MWST gebucht</td>
</tr>
<tr>
<td>Fakt.Entgelt</td>
<td>Total Warenbetrag pro Fakturanummer/Personen-ID</td>
</tr>
<tr>
<td>Fakt.MWSt</td>
<td>Total MWST-Betrag pro Fakturanummer/Personen-ID</td>
</tr>
<tr>
<td>Rekapitulation pro Code:</td>
<td></td>
</tr>
<tr>
<td>Code</td>
<td>MWST-Code</td>
</tr>
<tr>
<td>Kto</td>
<td>Konto</td>
</tr>
<tr>
<td>Brutto</td>
<td>Total (Entgelt + MWST gebucht pro Code/Kto)</td>
</tr>
<tr>
<td>Entgelt</td>
<td>Total (Warenbetrag pro Code/Kto)</td>
</tr>
<tr>
<td>MWSt gebucht</td>
<td>Total (gebucht MWST-Betrag pro Code/Kto)</td>
</tr>
<tr>
<td>MWSt errechnet</td>
<td>Total (errechnet MWST-Betrag pro Code/Kto)</td>
</tr>
<tr>
<td>Differenz</td>
<td>MWST (errechnet - MWST gebucht)</td>
</tr>
<tr>
<td>Anzahl</td>
<td>Anzahl der Fakturen (pro Code/Kto)</td>
</tr>
<tr>
<td>Satz</td>
<td>MWST-Satz in %</td>
</tr>
<tr>
<td>Basis</td>
<td>Basis für die Mehrwertsteuer- Abrechnung in Prozenten</td>
</tr>
<tr>
<td>I/E</td>
<td>I = MWST inklusive; E = MWST exklusive</td>
</tr>
<tr>
<td></td>
<td></td>
</tr>
<tr>
<td>Totale/Subtotale</td>
<td></td>
</tr>
<tr>
<td>Entgelt</td>
<td>Total pro Fakturanummer</td>
</tr>
<tr>
<td>MWSt gebucht</td>
<td>Total pro Fakturanummer</td>
</tr>
<tr>
<td>MWSt errechnet</td>
<td>Total pro Fakturanummer</td>
</tr>
<tr>
<td>Differenz</td>
<td>Total pro Fakturanummer</td>
</tr>
<tr>
<td>Fakt.Entgelt</td>
<td>Total pro Fakturanummer</td>
</tr>
<tr>
<td>Fakt.MWSt</td>
<td>Total pro Fakturanummer</td>
</tr>
<tr>
<td>Rekapitulation pro Code:</td>
<td></td>
</tr>
<tr>
<td>Entgelt</td>
<td>Total pro MWST-Code</td>
</tr>
<tr>
<td>MWSt gebucht</td>
<td>Total MWST-Code</td>
</tr>
<tr>
<td>MWSt errechnet</td>
<td>Total pro MWST-Code</td>
</tr>
<tr>
<td>Differenz</td>
<td>Total pro MWST-Code</td>
</tr>
<tr>
<td>Anzahl</td>
<td>Total Anzahl pro MWST-Code</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                17.02.1999 17:34:10 leh  Seite     0</span>
<span class="line"> </span>
<span class="line"></span>
<span class="line">                           EB-Mehrwertsteuer-Journal</span>
<span class="line"></span>
<span class="line">                 Achtung: Programm braucht 132 Zeichen / Zeile</span>
<span class="line"></span>
<span class="line">                 von Personen-ID.: 0          bis: 99,999,999</span>
<span class="line">                 von Journalnummer:   1010     bis:   1010</span>
<span class="line">                 von Datum........:            bis:</span>
<span class="line"></span>
<span class="line">                 Ausgabe von......:</span>
<span class="line">                 Mandanten........: \*</span>
<span class="line">                 nur mit Merkmal..:</span>
<span class="line"></span>
<span class="line">  FaktNr    Adresse Name       Datum    S        Entgelt  MWSt gebucht   MWSt errechnet  Differenz   Fakt.Entgelt     Fakt.MWSt</span>
<span class="line"> ------- ---------- ---------- -------- - -------------- ------------- ---------------- ---------- -------------- -------------</span>
<span class="line"> 1538658  1,617,343 Morf Vreni 25.03.97           207.75          0.00          0.00000    0.00000         207.75          0.00</span>
<span class="line"> 1538684  1,461,862 Roethlisbe 25.03.97            41.55          0.00          0.00000    0.00000          41.55          0.00</span>
<span class="line"> 1538685  1,105,396 Gubler Bea 25.03.97            41.55          0.00          0.00000    0.00000          41.55          0.00</span>
<span class="line"> .</span>
<span class="line"> .</span>
<span class="line"> 1538709    960,275 Hartmann L 25.03.97            35.85          0.00          0.00000    0.00000          35.85          0.00</span>
<span class="line"> 1639433  1,737,523 Elite Reis 26.03.97 1         -51.10         -3.30         -3.32150   -0.02150</span>
<span class="line">       .        .            .        . 2         -48.80         -1.00         -0.97600    0.02400         -99.90         -4.30</span>
<span class="line"> 1640135     27,262 Regionalgr 10.03.97 1          -0.60         -0.05         -0.03900    0.01100          -0.60         -0.05</span>
<span class="line"> 1640136     27,262 Regionalgr 10.03.97 1          -0.10          0.00         -0.00650   -0.00650          -0.10          0.00</span>
<span class="line"> 1640434  1,929,323 Hermann Ha 26.03.97 1         -28.15         -1.85         -1.82975    0.02025         -28.15         -1.85</span>
<span class="line"> 2000905  1,617,343 Morf Vreni 25.03.97          -166.20          0.00          0.00000    0.00000        -166.20          0.00</span>
<span class="line"> 2001000  1,492,887 Welti St.  25.03.97            -0.20          0.00          0.00000    0.00000          -0.20          0.00</span>
<span class="line"> 2001192  1,105,396 Gubler Bea 25.03.97           -13.85          0.00          0.00000    0.00000         -13.85          0.00</span>
<span class="line"> 2001197    489,976 Battaglia  25.03.97           -13.85          0.00          0.00000    0.00000         -13.85          0.00</span>
<span class="line"> .</span>
<span class="line"> .</span>
<span class="line"></span>
<span class="line"> 2    32021                     22,042.85      22,042.85          0.00        440.85700                   949   2.00   100 I</span>
<span class="line"> 2    32022                        223.05         223.05          0.00          4.46100                     6   2.00   100 I</span>
<span class="line"> 2    32023                        440.60           0.00        440.60          0.00000                     0   2.00   100 I</span>
<span class="line">                          --------------- -------------- ------------- ---------------- ---------- ----------</span>
<span class="line">                                22,706.50      22,265.90        440.60        445.31800    4.71800        955                  Total</span>
<span class="line"></span>
<span class="line">                          --------------- -------------- ------------- ---------------- ---------- ----------</span>
<span class="line">                               188,275.25     179,866.10      8,409.15      8,466.49350   57.34350      3,531                  Total</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


